

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const DOWNLOADALLDEPARTMENTS= createAsyncThunk(
  "downloadAllDepartments/downloadAllDepartments",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const downloadAllDepartmentsSlice = createSlice({
  name: "downloadAllDepartmentsSlice",
  initialState: {
    downloadAllDepartments: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdownloadAllDepartments: (state) => {
        state.downloadAllDepartments.loading = false
        state.downloadAllDepartments.error = false
        state.downloadAllDepartments.data = []
        state.downloadAllDepartments.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DOWNLOADALLDEPARTMENTS.fulfilled, (state, action) => {
      state.downloadAllDepartments = {
        ...state.downloadAllDepartments,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADALLDEPARTMENTS.pending, (state, action) => {
      state.downloadAllDepartments = {
        ...state.downloadAllDepartments,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADALLDEPARTMENTS.rejected, (state, action) => {
      state.downloadAllDepartments = {
        ...state.downloadAllDepartments,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const downloadAllDepartmentsAction = {
    DOWNLOADALLDEPARTMENTS,
};

export { downloadAllDepartmentsAction };
export default downloadAllDepartmentsSlice.reducer;
export const {setInitialStateOfdownloadAllDepartments} = downloadAllDepartmentsSlice.actions
